import styled from 'styled-components';
import { IThemeProvider } from '../../styles/theme';

export const ReportPredictiveStatesTableCont = styled.div`
  ${({ theme }: IThemeProvider) => `
    padding: 0 ${theme.layout.spacing.centy};
 `}
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${({ theme }: IThemeProvider) => `
    margin-top: ${theme.layout.spacing.mikro};
  `}
`;
